
import { defineComponent } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import schedulerTimingOutputOutputTabDescriptor from '../SchedulerTimingOutputOutputTabDescriptor.json'

export default defineComponent({
    name: 'scheduler-snapshot-accordion',
    components: { Accordion, AccordionTab },
    props: { propDocument: { type: Object } },
    data() {
        return {
            schedulerTimingOutputOutputTabDescriptor,
            document: null as any,
            snapshotNameDirty: false
        }
    },
    computed: {
        nameHelp(): string {
            return (this.document.snapshotname?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.snapshot.nameMaxLength
        },
        descriptionHelp(): string {
            return (this.document.snapshotdescription?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.snapshot.descriptionMaxLength
        }
    },
    watch: {
        propDocument() {
            this.loadDocument()
        }
    },
    created() {
        this.loadDocument()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument
            this.document.invalid.invalidSnapshot = false
            this.validateDocument()
        },
        setNameValidation() {
            this.snapshotNameDirty = true
            this.validateDocument()
        },
        validateDocument() {
            this.document.invalid.invalidSnapshot = !this.document.snapshotname || this.document.snapshotname.length === 0
        }
    }
})
